import { render, staticRenderFns } from "./DocumentApproval.vue?vue&type=template&id=a57e8414&scoped=true&"
import script from "./DocumentApproval.vue?vue&type=script&lang=js&"
export * from "./DocumentApproval.vue?vue&type=script&lang=js&"
import style0 from "./DocumentApproval.vue?vue&type=style&index=0&id=a57e8414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57e8414",
  null
  
)

export default component.exports